import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2024-03-15
 * @brief SEI 커뮤니티 사용자 메일 인증 성공
 *
 ********************************************************************/
import * as CUTIL from "../../../../utils/commUtils";
export default function OkCmmCertification() {
    function LoginGo(e) {
        CUTIL.jsopen_Popup(e);
    }
    return (_jsx(_Fragment, { children: _jsxs("fieldset", { children: [_jsx("p", Object.assign({ className: "login__info" }, { children: "\uBA54\uC77C \uC778\uC99D\uC774 \uC815\uC0C1\uC801\uC73C\uB85C \uC644\uB8CC \uB418\uC5C8\uC2B5\uB2C8\uB2E4." })), _jsx("button", Object.assign({ type: "button", className: "btn-login js-open", "data-pop": "pop-cmm-login", onClick: (e) => LoginGo(e) }, { children: _jsx("span", { children: "\uB85C\uADF8\uC778\uD558\uAE30" }) }))] }) }));
}
